import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormDiamond: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconFormDiamond"><Path d="M13.4142 2.91421C12.6332 2.13316 11.3668 2.13316 10.5858 2.91421L2.91421 10.5858C2.13316 11.3668 2.13316 12.6332 2.91421 13.4142L10.5858 21.0858C11.3668 21.8668 12.6332 21.8668 13.4142 21.0858L21.0858 13.4142C21.8668 12.6332 21.8668 11.3668 21.0858 10.5858L13.4142 2.91421Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
});

export default IconFormDiamond;
